import {
  Nav,
  ContainerImg,
  Logo,
  H1,
  ContainerH1,
  P,
  ContainerLinks,
  Link,
  ContainerSocialNetworks,
  A,
  ImgSN,
  LinkLogo,
} from "../styles/navbar";
import imgLogo from "../img/a.png";
import imgIconoGit from "../img/github.png";
import imgIconLinkedin from "../img/linkedin.png";

const NavBar = () => {
  return (
    <Nav>
      <ContainerImg>
        <LinkLogo to={"/"}>
          <Logo src={imgLogo}></Logo>
        </LinkLogo>
        <ContainerH1>
          <H1>Amador</H1>
          <P>Web Developer</P>
        </ContainerH1>
      </ContainerImg>

      <ContainerLinks>
        <Link to={"/about"}>Sobre mi</Link>
        <Link to={"/skills"}>Mis habilidades</Link>
        <Link to={"/works"}>Proyectos</Link>
        <Link to={"/contact"}>Contacto</Link>
      </ContainerLinks>

      <ContainerSocialNetworks>
        <A
          href="https://www.linkedin.com/in/amador-aguilar-full-stack/"
          target="_blank"
        >
          {" "}
          <ImgSN src={imgIconLinkedin} />
        </A>
        <A href="https://github.com/devAmador91" target="_blank">
          <ImgSN src={imgIconoGit} />
        </A>
      </ContainerSocialNetworks>
    </Nav>
  );
};

export default NavBar;
